/** Генератор идентификаторов для узлов, стен и проёмов. */
let counter = 0;

export const uid = (prefix: string) =>
	`${prefix}${(++counter).toString(36)}${Date.now().toString(36).slice(-4)}`;

/**
 * Id комнаты по её углам. Комнаты не хранятся, поэтому id должен быть воспроизводим:
 * одинаковый набор узлов — одна и та же комната, к которой привязаны пол, гидроизоляция
 * и стяжка. Порядок обхода не важен — узлы сортируются.
 */
export const roomIdOf = (nodeIds: string[]): string => `room:${[...nodeIds].toSorted().join("|")}`;
